import { Container } from '../../../odie';

import { CoffinBlockProps } from '../../defs/block';
import { blockPositionView } from '../../util/blockTools';
import { FitWidthBlockSprite } from './FitWidthBlockSprite';

const manifest = {
  coffin: 'coffin/block.coffin.png',
};

export class CoffinBlockView extends Container {
  constructor(props: CoffinBlockProps) {
    super();
    this.addChild(new FitWidthBlockSprite(manifest.coffin, props));
    blockPositionView(this, props);
    this.y += 1;
  }

  public static assets(): string[] {
    return [manifest.coffin];
  }
}
